import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth';

/**
 * Allows the route only for authenticated users. Anonymous visitors are
 * redirected to `/login` with the requested URL preserved in `returnUrl`.
 *
 * Relies on `appReadyMatch` (applied at the route level) to guarantee the
 * auth probe has settled before this guard runs — so the read here is
 * synchronous and definitive.
 */
export const authGuard: CanActivateFn = (_route, snapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) return true;

  return router.createUrlTree(['/login'], {
    queryParams: snapshot.url === '/' ? undefined : { returnUrl: snapshot.url },
  });
};
